import * as constants from './constants';
import { router } from './router';
import { menu } from './menu';
import { UzaverkaSkladu } from './uzaverkaSkladu';

export const Uzaverka = {
	name: constants.NAME,
	constants,
	router,
	menu,
	UzaverkaSkladu,
};
